import { memo } from 'react';
import { connect } from 'react-redux';

import utils from '../../utils/utils';

const mapStateToProps = (state) => {
	return {
		permissionsByFacility: state.user.permissionsByFacility
	};
};

const IsAuthorizedForFacility = (props) => {
	let isAuthorized;
	if (props.exactPermission) {
		if (Array.isArray(props.exactPermission)) {
			isAuthorized = props.exactPermission.some((permission) =>
				utils.isAuthorizedExact(permission, props.permissionsByFacility[props.facilityId])
			);
		} else {
			isAuthorized = utils.isAuthorizedExact(props.exactPermission, props.permissionsByFacility[props.facilityId]);
		}
	}

	if (isAuthorized) {
		return props.children;
	}
	if (props.readOnlyRender) {
		return typeof props.readOnlyRender === 'function' ? props.readOnlyRender() : props.readOnlyRender;
	}
	return null;
};

export default connect(mapStateToProps, null)(memo(IsAuthorizedForFacility));
